var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeAndSomeoneElseBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 65,
    viewBox: "0 0 70 65",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.917)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#D7D7D7",
    cx: 32.083,
    cy: 32.083,
    r: 32.083
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.083 64.167C14.364 64.167 0 49.802 0 32.083S14.364 0 32.083 0v64.167z",
    fill: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.667 8.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FF0008",
    cx: 23.333,
    cy: 23.333,
    r: 23.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.333 46.667C10.447 46.667 0 36.22 0 23.333 0 10.447 10.447 0 23.333 0v46.667z",
    fill: "#FF4C52"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.86 12.943)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 19.141,
    cy: 19.141,
    r: 19.141
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.813 11.857a5.666 5.666 0 0 0-5.661-5.659h-.011a5.65 5.65 0 0 0 0 11.302H27.152a5.664 5.664 0 0 0 5.66-5.643zM35.911 25.037c-2.075-3.875-5.124-6.256-8.53-6.261v.008c-.068-.001-.136-.008-.205-.008-2.444-.003-4.71 1.18-6.577 3.237 2.46 3.419 4.064 8.317 4.313 13.898a17.818 17.818 0 0 0 11-10.874z",
    fill: "#FF4C52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999 18.776v.008c-.068-.001-.136-.008-.204-.008-3.737-.005-7.058 2.81-9.152 7.32 2.708 6.411 9.045 10.91 16.431 10.91 1.436 0 2.83-.175 4.168-.496-.32-10.166-5.226-17.726-11.243-17.734zM17.5 11.857a5.666 5.666 0 0 0-5.66-5.659h-.011a5.65 5.65 0 0 0 0 11.302H11.839a5.664 5.664 0 0 0 5.661-5.643z",
    fill: "#FF0008"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeAndSomeoneElseBadge);
export default __webpack_public_path__ + "static/media/me-and-someone-else-badge.c1e7d1f75bab054f3c6b1351a604f613.svg";
export { ForwardRef as ReactComponent };